
<template>
  <div class="ProjectNumList">
    <el-container>
      <el-header>
        <el-form ref="form" :model="form" label-width="60px" :inline="true">
          <el-row>
            <el-col :span="6">
              <el-form-item label="子目名称" prop="subCategoryName">
                <el-input
                  v-model="form.subCategoryName"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="子目号" prop="subCategoryNo">
                <el-input
                  v-model="form.subCategoryNo"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="子目编码" prop="subCategorySerial">
                <el-input v-model="form.subCategorySerial" autocomplete="off"></el-input>
              </el-form-item>
            </el-col> -->

            <el-col :span="12">
              <div class="handlePanel">
                <el-button type="primary" @click="selectClick()"
                  >查询</el-button
                >
                <el-button type="info" @click="resetClick()">重置</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>

        <div style="clear: both"></div>
        <el-row>
          <el-col :span="24">
            <div class="handlePanel">
              <el-button
                type="primary"
                icon="el-icon-download"
                @click="downTemplate()"
                v-if="btnAuthorize.downloadTemplate.btnEnable"
                >下载模板</el-button
              >
              <el-button
                type="primary"
                icon="el-icon-upload2"
                @click="importProjectList()"
                v-if="btnAuthorize.import.btnEnable"
                >导入</el-button
              >
              <el-button
                type="primary"
                icon="el-icon-download"
                @click="exportCurrentList()"
                v-if="btnAuthorize.export.btnEnable"
                >导出</el-button
              >
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-main ref="main">
        <el-table
          ref="dataTable"
          :data="projectNumList"
          highlight-current-row
          size="mini"
          height="100%"
          @selection-change="handleSelectionChange"
          @row-click="rowClicked"
          @cell-dblclick="subCategoryDetail"
          border
        >
          <el-table-column
            type="index"
            width="50"
            label="序号"
          ></el-table-column>
          <el-table-column
            prop="subCategoryNo"
            label="子目号"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="subCategoryName"
            label="子目名称"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="unit"
            label="单位"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <!-- <el-table-column
            prop="unitPrice"
            label="单价"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{ scope.row[scope.column.property] | numFilter }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="操作" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="updBtnPressed(scope.row)"
                v-if="btnAuthorize.modifyBtn.btnEnable"
                >修改</el-button
              >
              <!-- <el-button
                type="text"
                size="mini"
                @click="delBtnPressed(scope.row)"
                v-if="btnAuthorize.delBtn.btnEnable"
                >删除</el-button
              > -->
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
        ></el-pagination>
      </el-footer>
    </el-container>
    <!--修改工程量清单弹窗 -->
    <el-dialog
      width="600px"
      :title="isAdd ? '详情' : '修改'"
      :visible.sync="isAddDialogShow"
      :before-close="closeAddDialog"
      :close-on-click-modal="false"
    >
      <el-form
        ref="addForm"
        :model="addForm"
        label-width="120px"
        :rules="addRules"
      >
        <el-row>
          <el-col :span="20">
            <el-form-item label="子目号" prop="subCategoryNo">
              <el-input
                v-model="addForm.subCategoryNo"
                autocomplete="off"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="子目名称" prop="subCategoryName">
              <el-input
                v-model="addForm.subCategoryName"
                autocomplete="off"
                :readonly="isAdd"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="单位" prop="unit">
              <el-input
                v-model="addForm.unit"
                autocomplete="off"
                :readonly="isAdd"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="20">
            <el-form-item label="单价" prop="unitPrice">
              <el-input
                v-model="addForm.unitPrice"
                autocomplete="off"
                :readonly="isAdd"
                @keyup.native="checkAmount(1)"
                @blur="Fornmat(1)"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="备注" prop="remarks">
              <el-input
                v-model="addForm.remarks"
                autocomplete="off"
                :readonly="isAdd"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="closeAddDialog" v-if="!isAdd"
          >取 消</el-button
        >
        <el-button type="primary" @click="saveBtnPressed()" v-if="!isAdd"
          >保 存</el-button
        >
        <el-button type="info" @click="closeAddDialog" v-if="isAdd"
          >关 闭</el-button
        >
      </div>
    </el-dialog>
    <!-- 导入工程量清单字典 -->
    <upload-dialog
      :isShow="showUploadDialog"
      @close="closeDialogAction"
      :isImportContract="isImportContractDialog"
      @saveImportItems="saveImportItems"
    />
  </div>
</template>

<script>
import {
  exportprojectDetailsDictList, //导出工程量清单字典
  getprojectDetailsListService, //获取工程量清单字典
  deleteProjectDetailsDictSevice,
  updateProjectDetailsDictService, //更新工程量清单数据
  getTemplate, //下载导入模板
  exportExcelService2, //导出
} from "../../services/allContractServices";
import { numFilter } from "@/utils/filters";
import UploadDialog from "./commonCell/UploadDialog"; //导入工程量清单字典

export default {
  name: "ProjectNumList",
  components: {
    UploadDialog,
  },
  data() {
    return {
      total: 0, //角色总数
      isAddDialogShow: false, //新增弹窗显示开关
      isAdd: false, //true新增 false修改角色标识
      projectNumList: [], //可选组织列表
      showUploadDialog: false, //导入工程量清单对话框可见性
      isImportContractDialog: true, //标记为导入工程量清单 false 导入物资采购
      menuRoleCode: "", //授权菜单的roleCode

      pageIndex: 1,
      pageSize: 20,
      showAdvanceFilter: false, //是否展开高级搜索
      form: {
        subCategoryNo: "", //子目号
        subCategoryName: "", //子目名称
        pageIndex: 1,
        pageSize: 20,
      },

      addForm: {
        id: "",
        subCategoryNo: "", //子目号
        subCategoryName: "", //子目名称
        unit: "", //单位
        // unitPrice: "", //单价
        // remarks: "",
      },
      addRules: {
        subCategoryNo: [
          { required: true, message: "请输入子目号" },
          // { min: 1, max: 20, message: "输入内容长度必须介于1到20之间" }
        ],
        subCategoryName: [
          { required: true, message: "请输入子目名称" },
          // { min: 1, max: 20, message: "输入内容长度必须介于1到20之间" }
        ],
        unit: [
          { required: true, message: "请输入单位" },
          // { min: 1, max: 20, message: "输入内容长度必须介于1到20之间" }
        ],
        // unitPrice: [
        //   { required: true, message: "请输入单价" },
        //   {
        //     pattern: /^[0-9,.]+$/,
        //     message: "只能输入数字",
        //   },
        //   // { min: 1, max: 20, message: "输入内容长度必须介于1到20之间" }
        // ],
      },

      //按钮权限
      btnAuthorize: {
        modifyBtn: { key: "update", btnEnable: false }, //修改
        delBtn: { key: "delete", btnEnable: false }, //删除
        import: { key: "import", btnEnable: false }, //导入
        export: { key: "export", btnEnable: false }, //导出
        downloadTemplate: { key: "downloadTemplate", btnEnable: false }, //下载模板
        // userBtn: { key: "2017111014583055253", btnEnable: false }
      },
    };
  },
  // watch: {
  //   "addForm.materialCoefficient": function (newValue) {
  //     //数量
  //     let amount = this.addForm.materialCoefficient.replace(/,/g, "");
  //     this.addForm.indirectExp = accMul(amount, this.addForm.materialPrice);
  //     this.addForm.calculateFormular1 = (this.addForm.indirectExp + "").replace(
  //       /^\D*(\d*(?:\.\d{0,2})?).*$/g,
  //       "$1"
  //     );
  //     this.addForm.calculateFormular1 = numFilter(
  //       this.addForm.calculateFormular1
  //     );
  //   },

  //   "addForm.materialPrice": function (newValue) {
  //     //单价
  //     let amount = this.addForm.materialCoefficient.replace(/,/g, "");
  //     this.addForm.indirectExp = accMul(amount, this.addForm.materialPrice);
  //     this.addForm.calculateFormular1 = (this.addForm.indirectExp + "").replace(
  //       /^\D*(\d*(?:\.\d{0,2})?).*$/g,
  //       "$1"
  //     );
  //     this.addForm.calculateFormular1 = numFilter(
  //       this.addForm.calculateFormular1
  //     );
  //   },
  // },
  props: {
    menuCode: {
      type: String,
    },
  },
  methods: {
    //激活时调用
    onActive(menuCode) {
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.initList();
    },
    /* 查询按钮回调 */
    selectClick() {
      this.form.pageIndex = 1;
      this.initList();
    },
    /* 重置按钮回调 */
    resetClick() {
      this.$refs.form.resetFields();
      this.initList();
    },

    //获取列表
    initList() {
      // let param = {
      //   // userId: sessionStorage.getItem("userCode"),
      //   pageIndex: this.pageIndex,
      //   pageSize: this.pageSize,
      // };

      getprojectDetailsListService(this.form)
        .then((res) => {
          if (res.code == 10000000) {
            this.projectNumList = res.data;
            this.total = res.total;
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    }, //
    /* 分页改变事件 */
    handleCurrentChange(page) {
      console.log(page);
      this.form.pageIndex = page;
      this.initList();
    },
    /* 分页显示数量改变事件 */
    handleSizeChange(rows) {
      this.form.pageSize = rows;
      this.form.pageIndex = 1;
      this.initList();
    },

    //下载工程量清单字典模板
    downTemplate() {
      let category = "PROJECT_DETAILS_BASE"; //工程量清单模板

      getTemplate(category).then(
        (res) => {
          console.log(res);
          if (res.code == 10000000) {
            exportExcelService2(res.data).then((res1) => {
              // this.$alert("成功", "提示", {
              //   confirmButtonText: "确定"
              // });
            });
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$message.error("系统异常");
        }
      );
    },
    /* 导入工程量清单*/
    importProjectList() {
      this.isImportContractDialog = true;
      this.showUploadDialog = true;
    },
    //保存导入的工程量清单
    saveImportItems(selectItems) {
      this.form.pageIndex = 1;
      this.initList();
    },
    /* 导出工程量清单字典 */
    exportCurrentList() {
      exportprojectDetailsDictList()
        .then((res) => {
          if (res.code == 10000000) {
            exportExcelService2(res.data).then((res1) => {
              this.$alert("导出成功", "提示", {
                confirmButtonText: "确定",
              });
            });
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch(() => {});
    },
    assignBtnPressed() {
      if (this.roleSelectedList.length != 1) {
        this.$alert("每次只能选择一条记录进行修改！", "提示");
      } else {
        this.menuRoleCode = this.roleSelectedList[0].id;
        this.$refs.RoleMenuAssignDialog.refreshMenu(this.menuRoleCode);
      }
    },
    accountAssignPressed() {
      if (this.roleSelectedList.length != 1) {
        this.$alert("每次只能选择一条记录进行修改！", "提示");
      } else {
        this.menuRoleCode = this.roleSelectedList[0].roleCode;
        this.$refs.RoleAccountAssignDialog.refreshAccount(this.menuRoleCode);
      }
    },
    closeAddDialog() {
      this.$refs.addForm.resetFields();
      this.isAddDialogShow = false;
    },
    /* 弹窗保存按钮回到 */
    saveBtnPressed() {
      this.$refs.addForm.validate((res) => {
        if (res) {
          if (this.isAdd) {
            this.addRow();
          } else {
            this.modifyRow();
          }
        }
      });
    },
    /* 修改信息 */
    modifyRow() {
      // this.addForm.updateUserId = sessionStorage.getItem("currentUserId");
      let data = { ...this.addForm };
      // data.unitPrice = data.unitPrice.toString().replace(/,/g, "");
      updateProjectDetailsDictService(data).then(
        (res) => {
          console.log(res);
          if (res.code == 10000000) {
            this.$alert("修改成功", "提示");
            this.isAddDialogShow = false;
            this.initList();
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 列表多选回调 */
    handleSelectionChange(roleList) {
      this.roleSelectedList = roleList;
    },
    // 点击选中行
    rowClicked(row, event, column) {
      this.$refs.dataTable.toggleRowSelection(row);
    },
    //双击查看该项详情
    subCategoryDetail(row) {
      this.isAdd = true; //true为查看详情
      this.isAddDialogShow = true;
      this.$nextTick(() => {
        this.addForm = Object.assign({}, row);
        // this.addForm.unitPrice = numFilter(this.addForm.unitPrice);
      });
    },
    /* 修改按钮回调 */
    updBtnPressed(row) {
      this.isAdd = false;
      this.isAddDialogShow = true;
      this.$nextTick(() => {
        this.addForm = Object.assign({}, row);
        // this.addForm.unitPrice = numFilter(this.addForm.unitPrice);
      });
    },
    /* 删除按钮回调 */
    delBtnPressed(row) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        // let roles = [];
        // this.roleSelectedList.forEach(role => {
        //   roles.push(role.roleId);
        // });
        let rowId = row.id;
        this.deleteRow(rowId);
      });
    },
    /* 删除工程量信息 */
    deleteRow(rowId) {
      let reqParam = {
        // userCode: sessionStorage.getItem("userCode"),
        id: rowId,
      };
      deleteProjectDetailsDictSevice(reqParam).then(
        (res) => {
          console.log(res);
          if (res.code == 10000000) {
            this.$alert("删除成功", "提示");
            this.isAddDialogShow = false;
            this.initList();
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$message.error("网络请求失败");
        }
      );
    },
    //关闭导入对话框
    closeDialogAction() {
      this.showUploadDialog = false;
    },
    //格式化金额
    checkAmount(val) {
      if (val == 1) {
        //材料单价
        this.addForm.unitPrice = (this.addForm.unitPrice + "").replace(
          /^\D*([,\d]*(?:\.\d{0,2})?).*$/g,
          "$1"
        );
        // this.addForm.amount = numFilter(this.addForm.amount);
      }
    },
    Fornmat(val) {
      if (val == 1) {
        //材料单价
        this.addForm.unitPrice = numFilter(this.addForm.unitPrice);
      } else {
        this.addForm.unitPrice = numFilter(this.addForm.unitPrice);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.ProjectNumList {
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
}
.screenPanel {
  text-align: left;
  min-height: 40px;
  padding: 16px 0 0 0;
}
.handlePanel {
  text-align: right;
  // padding: 0 20px;
}
.el-select {
  width: 100%;
}
.el-form-item__label {
  text-align: left;
}
.el-footer {
  text-align: right;
}
/deep/.el-radio-button__inner {
  background: #d5e7ed;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #fff;
  color: #069dbc;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
</style>
